// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"502":"dec4c112","6687":"258858d2","7302":"ac59b614"}[chunkId] + ".chunk.css";
};